// Shared pricing-ribbon renderer for product cards (industry-standard row:
// bold whole-unit selling price · grey struck MRP · green "N% OFF").
// Part of the card contract: consumers (variant swatches, infinite scroll)
// call window.webhqPriceRibbon instead of hand-rolling price markup.
window.webhqPriceRibbon = function (price) {
  if (!price) return '';

  function toNumber(value) {
    if (typeof value === 'number' && isFinite(value)) return value;
    if (!value) return null;
    var n = parseFloat(String(value).replace(/[^0-9.]/g, ''));
    return isFinite(n) && n > 0 ? n : null;
  }

  function currencySymbol(formatted) {
    if (!formatted) return '';
    var m = String(formatted).match(/^\s*([^\d\s.,-]+)/);
    return m ? m[1] : '';
  }

  var rate = toNumber(price.price_list_rate) || toNumber(price.formatted_price);
  if (!rate) return '';

  var mrp = toNumber(price.mrp) || toNumber(price.formatted_mrp);
  var symbol = currencySymbol(price.formatted_price) || currencySymbol(price.formatted_mrp);
  var fmt = new Intl.NumberFormat('en-IN', { maximumFractionDigits: 0 });

  var html = '<div class="product-price">' +
    '<span class="webhq-selling-price">' + symbol + fmt.format(rate) + '</span>';

  if (mrp && mrp > rate) {
    var pct = Math.round((1 - rate / mrp) * 100);
    var serverPct = toNumber(price.discount_percent);
    if (serverPct && serverPct >= 1) pct = Math.round(serverPct);
    html += ' <small class="striked-price"><s>' + symbol + fmt.format(mrp) + '</s></small>';
    if (pct >= 1) {
      html += ' <small class="ml-1 product-info-green">' + pct + '% OFF</small>';
    }
  }

  html += '</div>';
  return html;
};

frappe.ready(function () {
  if (!window.webshop) return;
	var isAllProductsPage = window.location && window.location.pathname === "/all-products";
	var isItemGroupListing = Boolean(document.querySelector('.item-group-content[data-item-group]'));
	var hasListingRoot = Boolean(document.getElementById('product-listing'));
	if (!isAllProductsPage && !isItemGroupListing && !hasListingRoot) {
		return;
	}

  function ensureCardItemCodes(root) {
    if (!root || !root.querySelectorAll) return;

    Array.prototype.forEach.call(root.querySelectorAll('.item-card, .list-row, .card'), function (node) {
      if (node.getAttribute('data-item-code')) return;
      var codeEl = node.querySelector('[data-item-code]');
      var code = codeEl ? codeEl.getAttribute('data-item-code') : null;
      if (code) {
        node.setAttribute('data-item-code', code);
      }
    });

    Array.prototype.forEach.call(root.querySelectorAll('.list-row'), function (row) {
      var code = row.getAttribute('data-item-code');
      if (!code) {
        var nested = row.querySelector('[data-item-code]');
        code = nested ? nested.getAttribute('data-item-code') : null;
      }
      if (!code) return;

      var listIndicator = row.querySelector('.cart-indicator.list-indicator');
      if (listIndicator && !listIndicator.getAttribute('data-item-code')) {
        listIndicator.setAttribute('data-item-code', code);
      }
    });
  }

  function patchGridMake() {
    if (!webshop.ProductGrid || webshop.ProductGrid.__raftorCardPatch) return;
    var originalMake = webshop.ProductGrid.prototype.make;
    webshop.ProductGrid.prototype.make = function () {
      originalMake.apply(this, arguments);
      var root = this.products_section && this.products_section[0];
      ensureCardItemCodes(root);
    };
    webshop.ProductGrid.__raftorCardPatch = true;
  }

  function patchListMake() {
    if (!webshop.ProductList || webshop.ProductList.__raftorCardPatch) return;
    var originalMake = webshop.ProductList.prototype.make;
    webshop.ProductList.prototype.make = function () {
      originalMake.apply(this, arguments);
      var root = this.products_section && this.products_section[0];
      ensureCardItemCodes(root);
    };
    webshop.ProductList.__raftorCardPatch = true;
  }

  patchGridMake();
  patchListMake();

  setTimeout(function () {
    ensureCardItemCodes(document.getElementById('product-listing'));
  }, 800);

  document.addEventListener('products-loaded', function () {
    setTimeout(function () {
      ensureCardItemCodes(document.getElementById('product-listing'));
    }, 50);
  });

  var listing = document.getElementById('product-listing');
  if (listing) {
    var timer = null;
    window.webhqDom.onAdded(function (roots) {
      var touchesListing = roots.some(function (r) {
        return r === listing || listing.contains(r) || r.contains(listing);
      });
      if (!touchesListing) return;
      if (timer) window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        ensureCardItemCodes(listing);
      }, 100);
    });
  }
});
